var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"primary":_vm.background.primary,"secondary":_vm.background.secondary}),_vm._l((_vm.colors),function(color,index){return _c('button',{key:index,style:({ backgroundColor: color.primary }),on:{"click":function($event){$event.preventDefault();return _vm.change(color)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }